import { Children, cloneElement, isValidElement, type ReactNode } from 'react'

type TabProps = {
  readonly id: string
  readonly children: ReactNode
}

type TabListProps = {
  readonly activeTabId: string
  readonly onTabChange: (id: string) => void
  readonly children: ReactNode
}

export function Tab({ children }: TabProps) {
  return <>{children}</>
}

export function TabList({ activeTabId, onTabChange, children }: TabListProps) {
  return (
    <div role="tablist" style={{ display: 'flex', gap: 'var(--o-space-2)' }}>
      {Children.map(children, (child) => {
        if (!isValidElement<TabProps>(child)) return child
        const id = child.props.id
        const selected = id === activeTabId
        return cloneElement(child, {
          children: (
            <button
              type="button"
              role="tab"
              aria-selected={selected}
              tabIndex={selected ? 0 : -1}
              className={selected ? 'btn btn-primary btn-sm' : 'btn btn-sm'}
              onClick={() => onTabChange(id)}
            >
              {child.props.children}
            </button>
          ),
        })
      })}
    </div>
  )
}
